webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(21),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TranslateForm__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TranslateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TranslateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TranslateOutput__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TranslateOutput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TranslateOutput__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    TranslateForm: __WEBPACK_IMPORTED_MODULE_0__components_TranslateForm___default.a,
    TranslateOutput: __WEBPACK_IMPORTED_MODULE_1__components_TranslateOutput___default.a
  },
  data: function data() {
    return {
      translatedText: ''
    };
  },
  methods: {
    translateText: function translateText(text, language) {
      var _this = this;

      this.$http.get('https://translate.yandex.net/api/v1.5/tr.json/translate?key=trnsl.1.1.20170629T113143Z.6dcd1841be276fa2.4f7bd4b8c474d1b7125bdecf127d8f0951b7be64&lang=' + language + '&text=' + text).then(function (response) {
        _this.translatedText = response.body.text[0];
      });
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'translateForm',
  data: function data() {
    return {
      textToTranslate: '',
      language: ''
    };
  },
  created: function created() {
    this.language = 'en';
  },

  methods: {
    formSubmit: function formSubmit(e) {
      this.$emit('formSubmit', this.textToTranslate, this.language);
      e.preventDefault();
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'translateOutput',
  props: ['translatedText']

});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(4);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(20),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6639f24d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(18),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(19),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "translateForm"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('form', {
    staticClass: "well form-inline",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": _vm.formSubmit
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textToTranslate),
      expression: "textToTranslate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input",
      "placeholder": "Enter some word"
    },
    domProps: {
      "value": (_vm.textToTranslate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textToTranslate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language),
      expression: "language"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "list"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hi"
    }
  }, [_vm._v("Hindi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pa"
    }
  }, [_vm._v("Punjabi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v("French")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zh"
    }
  }, [_vm._v("Chinese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ja"
    }
  }, [_vm._v("Japanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mr"
    }
  }, [_vm._v("Marathi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bn"
    }
  }, [_vm._v("Bengali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "az"
    }
  }, [_vm._v("Azerbaijan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sq"
    }
  }, [_vm._v("Albanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "am"
    }
  }, [_vm._v("Amharic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ar"
    }
  }, [_vm._v("Arabic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hy"
    }
  }, [_vm._v("Armenian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "af"
    }
  }, [_vm._v("Afrikaans")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "eu"
    }
  }, [_vm._v("Basque")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ba"
    }
  }, [_vm._v("Bashkir")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "be"
    }
  }, [_vm._v("Belarusian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "my"
    }
  }, [_vm._v("Burmese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bg"
    }
  }, [_vm._v("Bulgarian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bs"
    }
  }, [_vm._v("Bosnian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cy"
    }
  }, [_vm._v("Welsh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hu"
    }
  }, [_vm._v("Hungarian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vi"
    }
  }, [_vm._v("Vietnamese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ht"
    }
  }, [_vm._v("Haitian (Creole)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gl"
    }
  }, [_vm._v("Galician")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nl"
    }
  }, [_vm._v("Dutch")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mrj"
    }
  }, [_vm._v("Hill Mari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "el"
    }
  }, [_vm._v("Greek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ka"
    }
  }, [_vm._v("Georgian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gu"
    }
  }, [_vm._v("Gujarati")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Danish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "he"
    }
  }, [_vm._v("Hebrew")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yi"
    }
  }, [_vm._v("Yiddish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("Indonesian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ga"
    }
  }, [_vm._v("Irish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "it"
    }
  }, [_vm._v("Italian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is"
    }
  }, [_vm._v("Icelandic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kk"
    }
  }, [_vm._v("Kazakh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kn"
    }
  }, [_vm._v("Kannada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ca"
    }
  }, [_vm._v("Catalan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ky"
    }
  }, [_vm._v("Kyrgyz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ko"
    }
  }, [_vm._v("Korean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "la"
    }
  }, [_vm._v("Latin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ml"
    }
  }, [_vm._v("Malayalam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ne"
    }
  }, [_vm._v("Nepali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("Norwegian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fa"
    }
  }, [_vm._v("Persian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pl"
    }
  }, [_vm._v("Polish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt"
    }
  }, [_vm._v("Portuguese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ru"
    }
  }, [_vm._v("Russian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ta"
    }
  }, [_vm._v("Tamil")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tr"
    }
  }, [_vm._v("Turkish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ur"
    }
  }, [_vm._v("Urdu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sv"
    }
  }, [_vm._v("Swedish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "te"
    }
  }, [_vm._v("Telugu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gd"
    }
  }, [_vm._v("Scottish")])]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "Translate"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v(_vm._s(_vm.translatedText))])
},staticRenderFns: []}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('TranslateForm', {
    on: {
      "formSubmit": _vm.translateText
    }
  }), _vm._v(" "), _c('TranslateOutput', {
    domProps: {
      "textContent": _vm._s(_vm.translatedText)
    }
  }), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('img', {
    attrs: {
      "src": __webpack_require__(14)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "color": "purple",
      "position": "absolute",
      "bottom": "0",
      "left": "45%"
    }
  }, [_vm._v("Made with "), _c('i', {
    staticClass: "fa fa-code animated flash",
    attrs: {
      "aria-hidden": "true",
      "id": "code"
    }
  }), _vm._v(" and Vue.js")])
}]}

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[9]);


// WEBPACK FOOTER //
// static/js/app.d5d090acdcaf97a98785.js